import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  getHasAnyFavouriteTemplates,
  getIdsOfFavouriteTemplates,
  getIsFetching,
  makeGetIsTemplateFavourite,
} from "../selectors";
import { TemplateId } from "../../../globalTypes";

export const useIsFavouriteFetching = () => useSelector(getIsFetching);

export const useIsFavourite = (templateId: TemplateId) => {
  const getIsFavourite = useMemo(makeGetIsTemplateFavourite, [templateId]);
  return useSelector((state) => getIsFavourite(state, templateId));
};

export const useFavouriteIds = () => useSelector(getIdsOfFavouriteTemplates);

export const useHasAnyFavouriteTemplates = (): boolean =>
  useSelector(getHasAnyFavouriteTemplates);
